import {useTranslation} from 'react-i18next';
import Text from './Text';
import {BadgeImgTextType, BadgeWaitfree} from '../type';

interface Props {
  imgTextType: BadgeImgTextType;
  label: string;
  waitfree?: BadgeWaitfree;
  path: string;
  height: number;
  className?: string;
  textClassName?: string;
  bgClassName?: string;
}

export default function BadgeImgText({
  imgTextType,
  label: _label,
  waitfree,
  path,
  height,
  className,
  textClassName,
  bgClassName,
}: Props) {
  const {t} = useTranslation();
  const style = {height};
  const label = waitfree
    ? t(WAITFREE_TEXT_KEY_MAP[imgTextType], {value: waitfree.hours})
    : _label;

  return (
    <div className="flex">
      <img src={path} alt={label} style={style} />
      <Text
        className={cn(
          'font-number rounded-r-5 flex items-center px-3 !whitespace-nowrap',
          className,
          textClassName,
          bgClassName
        )}
        style={style}
      >
        {label}
      </Text>
    </div>
  );
}

const WAITFREE_TEXT_KEY_MAP: {[key in BadgeImgTextType]: string} = {
  waitForFreePlus: 'common_gidamu_plus',
  waitForFreePlusTimer: 'common_gidamu_plus',
  waitForFreePlusExtended: 'common_gidamu_plus_long',
  waitForFreeExtended: '',
  waitForFreeNotice: '',
  waitForFreeNoticeCharging: '',
};
